import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, canAccessMemberArea, isAuthReady } = useAuth();

  if (!isAuthReady) {
    return null;
  }

  if (!isAuthenticated || !canAccessMemberArea) {
    return <Navigate to="/authentification" replace />;
  }

  return children;
}
